const init = () => {
    videoControlsInit();
    globalClickListener();
    window.resize(() => {
        mobileAccordion();
    });
    mobileAccordion();
    a11yFixes();
    partInquiry();
    klaviyoBackInStock();
};
const klaviyoBackInStock = () => {
    const styleButton = () => {
        document.querySelectorAll('#klaviyo-bis-button-container button:not(.btn--primary)').forEach((button) => {
            button.classList.add('btn', 'btn--primary');
        });
    };

    styleButton();
    const observer = new MutationObserver(styleButton);
    observer.observe(document.body, { childList: true, subtree: true });
};
const partInquiry = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const part = queryParams.get('part');
    const customerEmail = window?.customerData?.email;
    const path = window.location.pathname;
    if (path === '/pages/part-inquiry') {
        // Function to find an element inside any Shadow DOM
        function findInShadows(selector) {
            const allElements = document.querySelectorAll('*');
            for (const el of allElements) {
                if (el.shadowRoot) {
                    const found = el.shadowRoot.querySelector(selector);
                    if (found) return found;
                }
            }
            return null;
        }
        function setValue(selector, value) {
            const input = findInShadows(selector);
            if (input) {
                input.value = value;
                input.dispatchEvent(new Event('input', { bubbles: true }));
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
        if (part) {
            setValue('input#custom\\#part_name', part);
        }
        if (customerEmail) {
            setValue('#email', customerEmail);
        }
    }
};
const a11yFixes = () => {
    const links = document.querySelectorAll('a[target="_blank"]:not([aria-label*="new window"])');
    if (links) {
        links.forEach((link, ind) => {
            link.setAttribute('aria-label', `Open ${encodeURIComponent(link.textContent.trim())} in new window`);
        });
    }
};
const mobileAccordion = () => {
    const isDesktop = window.screen.width >= 750;
    const specific = isDesktop ? ':not([open])' : '[open]';
    const mobileAccordions = document.querySelectorAll(`.mobile-accordion${specific}`);
    if (mobileAccordions.length) {
        mobileAccordions.forEach(el => {
            if (isDesktop) {
                el.setAttribute('open', '');
            }
            else {
                el.removeAttribute('open');
            }
        });
    }
};
const globalClickListener = () => {
    document.body.addEventListener('click', function (e) {
        const target = e.target;
        if (window.screen.width < 800) {
            if (target.classList.contains('footer-block__heading')) {
                const dropdownEl = target.closest('.footer-block-content');
                const isOpen = dropdownEl.classList.contains('open');
                if (isOpen) {
                    dropdownEl.classList.remove('open');
                } else {
                    dropdownEl.classList.add('open');
                }
            }
        }
        readMore(target, e);
    });
};
const readMore = (target, e) => {
    if (target.classList.contains('read-more')) {
        e.preventDefault();
        target.closest('.read-more-container').classList.add('expanded');
    }
    if (target.classList.contains('read-more-btn')) {
        e.preventDefault();
        const readMoreContainer = target.closest('.read-more-container');
        if (readMoreContainer.classList.contains('expanded')) {
            readMoreContainer.classList.remove('expanded');
        }
        else {
            readMoreContainer.classList.add('expanded');
        }
    }
};
const videoControlsInit = () => {
    let isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const videoToggles = [...document.querySelectorAll('.utility-btn')];
    if (videoToggles.length !== 0) {
        videoToggles.forEach((videoToggle) => {
            const video = videoToggle.parentElement.querySelector('video');
            if (!!video) {
                videoToggle.addEventListener('click', function (e) {
                    e.preventDefault();
                    const videoEl = this.parentElement.querySelector('video');
                    const videoPlay = videoEl.paused || videoEl.ended;
                    videoEl.controls = 0;
                    if (videoPlay) {
                        videoEl.play();
                        videoEl.classList.add('keep-playing');
                        videoEl.parentElement.classList.add('playing');
                        videoToggle.setAttribute('aria-label', 'pause video');
                        videoToggle.classList.add('active');
                    } else {
                        videoEl.pause();
                        videoEl.classList.remove('keep-playing');
                        videoEl.parentElement.classList.remove('playing');
                        videoToggle.setAttribute('aria-label', 'play video');
                        videoToggle.classList.remove('active');
                    }
                });
                video.classList.add('keep-playing');
                if (isMobileDevice) {
                    video.pause();
                    video.classList.remove('keep-playing');
                    video.parentElement.classList.remove('playing');
                    videoToggle.setAttribute('aria-label', 'play video');
                    videoToggle.classList.remove('active');
                }
            }
        });
        const videos = document.querySelectorAll('video');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const videoEl = entry.target;
                const isPlay = videoEl.paused && videoEl.classList.contains('keep-playing');
                const isPause = entry.intersectionRatio === 0 && !videoEl.paused;
                if (isPause) {
                    videoEl.pause();
                    videoEl.parentElement.classList.remove('playing');
                    let toggle = videoEl.parentElement.querySelector('.utility-btn');
                    toggle.setAttribute('aria-label', 'play video');
                    toggle.classList.remove('active');
                } else if (isPlay) {
                    videoEl.play();
                    videoEl.parentElement.classList.add('playing');
                    let toggle = videoEl.parentElement.querySelector('.utility-btn');
                    toggle.setAttribute('aria-label', 'pause video');
                    toggle.classList.add('active');
                }
            });
        });
        videos.forEach((video) => {
            observer.observe(video);
        });
    }
};
class SeparatedList extends HTMLElement {
    constructor() {
        super();
        const that = this;
        window.resize(() => {
            const items = that.querySelectorAll('li');
            items.forEach((item, itemIndex) => {
                const previousItem = items[itemIndex - 1];
                const nextItem = items[itemIndex + 1];
                item.classList.toggle('first-of-row', !previousItem || item.offsetTop !== previousItem.offsetTop);
                item.classList.toggle('last-of-row', !nextItem || item.offsetTop !== nextItem.offsetTop);
            });
        });
    }
}
customElements.define('separated-list', SeparatedList);

window.onload = () => {
    init();
};
